import { SIDEBAR_ACTIONS } from "../../../../constants/actionsConstants";

export const openSidebar = (dispatch, payload) => {
  dispatch({
    type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
    payload
  });
};

export const closeSidebar = (dispatch, componentKey) => {
  dispatch({
    type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR,
    payload: { componentKey }
  });
};
